export const TIMELINE = [
  {
    quarter: 4,
    year: 2020,
    desc: 'Descartes Network was founded.',
  },
  {
    quarter: 1,
    year: 2021,
    desc: 'Collaborate with Sentre Protocol.',
  },
  {
    quarter: 2,
    year: 2021,
    desc: 'Sentre Protocol project development.',
  },
  {
    quarter: 3,
    year: 2021,
    desc: 'Support Sentre Protocol launching.',
  },
  {
    quarter: 4,
    year: 2021,
    desc: 'Succeed in fundraising.',
  },
  {
    quarter: 1,
    year: 2022,
    desc: 'Collaborate with Coin98 Wallet.',
  },
  {
    quarter: 2,
    year: 2022,
    desc: 'Collaborate with InterDAO and support Solana Vietnam Coding Camp season 1.',
  },
  {
    quarter: 3,
    year: 2022,
    desc: 'Collaborate with Any Arts.',
  },
]
